import React, { ReactNode, useEffect, useState } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const [currentError, setCurrentError] = useState<Error | null>(null)

  useEffect(() => {
    window.onerror = (message, source, lineno, colno, error) => {
      setCurrentError(error !== undefined ? error : null)
      return true
    }

    const handlePromiseRejection = (event: PromiseRejectionEvent) => {
      setCurrentError(event.reason)
    }
    window.addEventListener('unhandledrejection', handlePromiseRejection)

    return () => {
      window.onerror = null
      window.removeEventListener('unhandledrejection', handlePromiseRejection)
    }
  }, [])

  return currentError ? <div>{currentError.toString()}</div> : children
}

export default ErrorBoundary
